<template >
   <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('cerrar')">
        <v-card
            class="mx-auto"
            max-width="550"
          >
            <v-img
              class="white--text align-end"
              :src="gram.media_url"
            >
              <v-card-title class="titulo-insta">{{ this.titulo }}</v-card-title>
            </v-img>
            

            <v-card-actions>
              <v-card-text class="text--primary">
                <div><span class="fecha-insta" >{{ this.fecha }}</span>
                  <div style="float:right"><i class="icon-heart5"> {{ this.gram.like_count }}</i>&nbsp;&nbsp;<i class="icon-bubble"> {{ this.gram.comments_count }}</i></div>
                </div>
              </v-card-text>
              <v-btn
                fab dark depressed small color="cyan"
                :href="url"
              >
              <i class="icon-instagram"></i>
              </v-btn>
            </v-card-actions>
          </v-card>
      </div>
    </div>
</template>
<script>


export default {
  data () {
    return {
      titulo:'',
      fecha: '',
      url: '',
    }
  },
  props: {
    gram: Object
  },
  created () {
    console.log(this.gram)
    this.init()
  },
  methods: {
    init () {
      this.fecha = new Date( this.gram.timestamp).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })
      // if (this.gram.node.edge_media_to_caption.edges[0].node.text) {
      //   // this.titulo = this.gram.node.edge_media_to_caption.edges[0].node.text
      //   this.titulo = ''
      // }
      this.url = this.gram.permalink
    }
  }
}
</script>
